import type { ActionState, OverrideWindow } from '../api/types'
import { chipFor, fmtTime } from '../lib/schedule'

interface Props {
  action: ActionState | null | undefined
  activeWindow?: OverrideWindow
}

/**
 * Live "what is the battery doing, and why" chip. Shows the time of the
 * engine's last decision when it is more than 10 minutes old, so a stale
 * chip is never mistaken for a live one.
 */
export function ActionChip({ action, activeWindow }: Props) {
  const chip = chipFor(action, activeWindow)
  if (!chip) return null
  const updated = action?.updated_at ? new Date(action.updated_at) : null
  const stale = updated ? Date.now() - updated.getTime() > 10 * 60_000 : false
  return (
    <span className={`action-chip action-chip-${chip.tone}`} role="status">
      <span className="action-chip-dot" aria-hidden="true" />
      {chip.text}
      {stale && updated && <span className="action-chip-age"> (as of {fmtTime(updated)})</span>}
    </span>
  )
}
